export const moveToAnchor = (link: string) => {
    let elem = document.getElementById(link)
    if (elem) {
        elem.scrollIntoView({behavior: "smooth"})
    }
}